import { render, staticRenderFns } from "./UploadFileButton.vue?vue&type=template&id=58afbe27&scoped=true"
import script from "./UploadFileButton.vue?vue&type=script&lang=js"
export * from "./UploadFileButton.vue?vue&type=script&lang=js"
import style0 from "./UploadFileButton.vue?vue&type=style&index=0&id=58afbe27&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58afbe27",
  null
  
)

export default component.exports